import React, { FC } from 'react';
import styled from 'styled-components';
import {
  BROWSER_BREAKPOINTS,
  DetailsItem,
  DetailsWrapper,
  Typography,
} from '@flicent/fieldpulse-react-component-library-frontend';

import JobVisitsProps from './JobVisits.props';


const StyledRoot = styled.div`
  display: grid;
  grid-row-gap: 50px;

  font-family: "Open Sans", sans-serif;

  @media screen and (${ BROWSER_BREAKPOINTS.MOBILE }) {
    grid-row-gap: 16px;
  }
`;

const StyledItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 20px;
`;

const JobVisits: FC<JobVisitsProps> = ({ job }) => {
  if (!job.is_visits_visible || !job.visits.length) {
    return null;
  }

  return (
    <StyledRoot>
      {
        job.visits.map(({ title, display_time, location_title, location, status_name, members }, index) => (
          <StyledItem key={ index }>
            <Typography variant="h1" color="blue">{ title }</Typography>

            <DetailsWrapper>
              <DetailsItem label="Date/Time" value={ display_time }/>
              <DetailsItem label="Location" value={ location }/>
              <DetailsItem label="Status" value={ status_name }/>
              { job.is_job_location_title_visible && <DetailsItem label="Location Name" value={ location_title }/> }
              <DetailsItem label="Assigned Team Members" value={ members }/>
            </DetailsWrapper>
          </StyledItem>
        ))
      }
    </StyledRoot>
  );
};


export default JobVisits;